import React from "react";
import ReactDOM from "react-dom";
import { Program, CurriculumItem } from "@/interfaces/Bootcamp";

interface ModalProps {
  program: Program | null;
  onClose: () => void;
}



const ProgramDetailModal = ({ program, onClose }: ModalProps) => {
  if (!program) return null;

  const modalContent = (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[9999] p-4">
      <div className="relative shadow-xl rounded-lg overflow-visible w-full max-w-md sm:max-w-4xl bg-white ">
        <div className="bg-white rounded-t-lg p-6 sm:p-8 pb-0">
          <div className="flex items-center justify-between ">
            <h2 className="text-xl sm:text-2xl font-bold text-gray-800">
              {program.title}
            </h2>
            <a
              href="https://wa.me/6281215636018"
              target="_blank"
              className="bg-teal-600 text-white px-4 py-2 rounded text-base hover:bg-black duration-300"
            >
              Daftar Sekarang
            </a>
          </div>
        </div>

        <div className="bg-white max-h-[70vh] overflow-y-auto rounded-b-lg p-6 mt-2 sm:p-8 pt-4 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
          <div className="grid grid-cols-1 sm:grid-cols-[160px_1fr] gap-y-4 gap-x-6 text-sm text-gray-700 mt-4 md:-mt-6">
            <div className="font-bold">Deskripsi</div>
            <div>{program.description}</div>

            <div className="font-bold">Durasi</div>
            <div>{program.duration}</div>

            <div className="font-bold">Mekanisme Belajar</div>
            <div>{program.learningMethod}</div>

            <div className="font-bold">Materi</div>
            {program.curriculum && program.curriculum.length > 0 && (
              <>
                {typeof program.curriculum[0] === "string" ? (
                  <ul className="list-disc pl-5 space-y-1">
                    <li className="list-none font-semibold -mx-5">Topik Pembelajaran : </li>
                    {(program.curriculum as string[]).map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                ) : (
                  <ol className="list-decimal pl-5 space-y-2">
                    <li className="list-none font-semibold -mx-5">Topik Pembelajaran : </li>
                    {(program.curriculum as CurriculumItem[]).map((group, index) => (
                      <li key={index} value={index + 1}>
                        <div className="font-semibold">{group.title}</div>
                        {group.subtopics && group.subtopics.length > 0 && (
                          <ul className="list-disc pl-6 space-y-1">
                            {group.subtopics.map((sub, i) => (
                              <li key={i}>{sub}</li>
                            ))}
                          </ul>
                        )}
                      </li>
                    ))}
                  </ol>
                )}
              </>
            )}


            {program.tugasDanUjian && (
              <>
                <div className="font-bold">Tugas dan Ujian</div>
                <ul className="list-disc pl-5 space-y-1">
                  <li className="list-none font-semibold -mx-5">Penugasan dan Ujian : </li>
                  {program.tugasDanUjian?.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </>
            )}

            {program.fasilitas && (
              <>
                <div className="font-bold">Fasilitas</div>
                <ul className="list-disc pl-5 space-y-1">
                  <li className="list-none font-semibold -mx-5">Fasilitas yang didapatkan</li>
                  {program.fasilitas?.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </>
            )}

            {program.ujiSertifikasi && (
              <>
                <div className="font-bold">Uji Sertifikasi</div>
                <ul className="list-disc pl-5 space-y-1">
                  <li className="list-none font-semibold -mx-5">Ujian sertifikasi</li>
                  <li>{program.ujiSertifikasi}</li>
                </ul>
              </>
            )}

            <div className="font-bold">Biaya</div>
            <div className="text-red-600 font-bold">{program.price}</div>
          </div>
        </div>

        <button
          onClick={onClose}
          className="absolute -top-5 -right-5 w-12 h-12 flex items-center justify-center font-bold shadow-lg bg-gray-300 rounded-full text-gray-700 hover:bg-gray-400 text-3xl"
        >
          <span className="relative -top-[3px]">&times;</span>
        </button>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

export default ProgramDetailModal;
